export const Z_INDEX_HIGHLIGHT = 100000;
export const Z_INDEX_TARGET_ELEMENT = Z_INDEX_HIGHLIGHT + 1;